<template>
  <div class="analyse">

    

    <v-card>
      <v-card-text v-if="loading" class="text-xs-center pt-3">
        <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
      </v-card-text>

      
      <v-container v-else fluid grid-list-md>
        <v-layout row wrap>
          <!-- Colonne gauche : saisie -->
          <v-flex xs12 sm4>
            <v-card class="pa-3">
              <v-select
                v-model="suggestionsProxy"
                :items="questions"
                item-text="valeur"
                item-value="cle"
                label="Analyses"
                multiple
                chips
                return-object
                hint="paramétrez votre analyse"
                persistent-hint
              />
              <v-textarea
                v-model="analyseMessage"
                label="Votre demande personalisée"
                clearable
                auto-grow
                outlined
              ></v-textarea>

              <v-btn
                :loading="loadingData"
                :disabled="loadingData"
                color="primary"
                block
                class="mt-2"
                @click="sendMAnalyseChat"
              >
                Analyser
              </v-btn>
            </v-card>
          </v-flex>

          <!-- Colonne droite : réponse -->
          <v-flex xs12 sm8>
            <v-card class="pa-3" height="100%">
              <v-card-text>
                <div v-html="analyseResponse" class="markdown-output text-xs-left"></div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="text-xs-left">
        <v-btn flat @click="openChats()" color="accent" v-if="histoready">
          {{ $t('hideChat') }}
          <v-icon  right>visibility_off</v-icon>
        </v-btn>
        <v-btn flat @click="openChats()" color="accent" v-else>
          {{ $t('showChat') }}
          <v-icon right>visibility</v-icon>
        </v-btn>
      </div>
    </v-card>

    <!-- Historique des chats -->
    <wz-histo-chats
      :params="params"
      :numChatsTotal="String(chatsOK)"
      v-if="histoready"
    ></wz-histo-chats>

  </div>
</template>

<script>
import _ from 'lodash'
import json2csv from 'json2csv'
import moment from 'moment'
import MarkdownIt from 'markdown-it'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      md: new MarkdownIt(),
      suggestions: {},       // ton objet clé: valeur
      questions: [
        {
          cle: `q1`,
          valeur: `Statistiques générales`,
          description: `
            Durée totale de la conversation (entre le 1er et le dernier message).
            Nombre total de conversations avec differents visiteur.
            Nombre total de messages.
            Répartition des messages par auteur (visiteur / agent).
            Moyenne de temps entre deux messages (si données temporelles disponibles).
          `
        },
        {
          cle: `q2`,
          valeur: `Analyse des questions`,
          description: `
            Liste de toutes les questions posées par les visiteurs.
            Pour chaque question, indique si elle a reçu une réponse satisfaisante, partielle ou aucune réponse.
            Signale les répétitions (si le visiteur a reposé la même question).
          `
        },
        {
          cle: `q3`,
          valeur: `Intentions et besoins`,
          description: `
            Les intentions principales du visiteur (ex. obtenir un document, rechercher une offre, poser une question générale).
            Les besoins explicites et implicites.
          `
        },
        {
          cle: `q4`,
          valeur: `Points de blocages`,
          description: `
            Identifier où le bot n’a pas pu répondre correctement.
            Détecter les éventuelles relances ou signaux de frustration.
          `
        },
        {
          cle: `q5`,
          valeur: `Actions exploitable pour un conseiller humain`,
          description: `
            Questions non résolues.
            Actions détaillées à entreprendre pour clôturer les demandes non résolues et améliorer la convivialité.
            Actions détaillées à entreprendre pour améliorer les ventes et la satisfaction du visiteur.
          `
        },
        {
          cle: `q6`,
          valeur: `Résumé des conversations`,
          description: `
            En 3 à 5 phrases simples, résumer les conversations et préciser ce qui reste à traiter.
          `
        },
        {
          cle: `q7`,
          valeur: `Opportunité commerciale`,
          description: `
            Les conversations montrent-t-elle des opportunités commerciale claire (ex : voyage, réservation, achat potentiel) ? Si oui, laquelle et comment l’exploiter ?
          `
        },
        {
          cle: `q8`,
          valeur: `Satisfaction probable du visiteur`,
          description: `
            Estime le niveau de satisfaction probable des visiteurs à la fin des conversations. Donne un score entre 1 (très insatisfait) et 5 (très satisfait), puis explique pourquoi.
          `
        },
        {
          cle: `q9`,
          valeur: `Proximité avec une décision d’achat`,
          description: `
            Les visiteurs sont-ils proche de prendre une décision d’achat (ex : dates précises, nombre de nuits, recherche répétée) ? Justifie ta réponse.
          `
        },
        {
          cle: `q10`,
          valeur: `Opportunité de cross-sell / upsell`,
          description: `
            Les conversations laissent-t-elles apparaître des opportunités de proposer un produit complémentaire (ex : excursions, assurance, chambre supérieure) ? Justifie ta réponse.
          `
        }
      ],
      analyseMessage: '',
      analyseResponse: '',
      loading: false,
      loadingData: false,
      loadingExportData: false,
      chatsOK: 0,
      nbMessages: 0,
      panel: [true, false],
      visiteurs: [],
      histoready: false,
      filterChats: {
        type: Boolean,
        default: false
      }
    }
  },

  created () {
    // initialisation des options liées aux graphiques
    this.chatsMissed = _.merge(this.chatsMissed, this.optionsJauge)
    this.getAll()
  },

  methods: {
    /**
     * lance toutes les requêtes
     */
    getAll () {
      // affichage des loader
      this.loading = true
      Promise.all([
        this.getChatsAnalyse()
      ])
    },
    download () {
      this.loadingExportData = true
      let csv = null
      const fields = [
        'chats',
        'messages'
      ]
      const fieldNames = [
        this.$tc('chats', 2, { count: '' }),
        this.$tc('messages', 2, { count: '' })
      ]
      const data = {
        chats: this.chatsOK,
        messages: this.nbMessages
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        this.loadingExportData = false
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      this.loadingExportData = false
    },
    onSelectChange (values) {
      // transformer le tableau en objet clé: valeur
      this.suggestions = values.reduce((acc, item) => {
        acc[item.cle] = item.valeur
        return acc
      }, {})
    },
    openChats (indexPage) {
      // console.log('openChats', this.params)
      if (this.histoready) {
        this.histoready = false
      } else {
        this.histoready = true
      }
    },

    getChatsAnalyse () {
      console.log('getChatsAnalyse', this.params)
      this.loadingHisto = true
      this.loading = true
      this.axios
        .get('get/chats_analyse.php?' + this.params)
        .then(response => {
          // vide le tableau des visiteurs
          this.visiteurs = _.isArray(response.data) ? response.data : []
          // this.allCarousels = _.cloneDeep(this.visiteurs)
          _.each(this.visiteurs, visiteur => {
            visiteur.duration = moment
              .duration(visiteur.duration, 'seconds')
              .format('h [h] m [m] s [s]')
            visiteur.averageResponse = moment
              .duration(visiteur.averageResponse, 'seconds')
              .format('h [h] m [m] s [s]')
            // chaque conversation
            _.each(visiteur.chats, conversation => {
              _.each(conversation.messages, message => {
                message.text = message.text.replaceAll('&lt;', '<')
                message.text = message.text.replaceAll('&gt;', '>')
                if (message.text === 'undefined') message.text = null
                message.unix = message.date
                if (message.agentName === 'undefined') {
                  let userFound = this.$store.getters['_User/getUserById'](
                    message.agentId
                  )
                  message.agentName = userFound
                    ? userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME
                    : ''
                }
                let date = moment.unix(message.unix)
                message.date = date.format('LTS')
                conversation.last = _.clone(message)
                conversation.last.date = date.calendar()
              })
            })
          })

          // Affichage par défaut du premier chat
          // du premier visiteur
          if (this.chatsSorted[0]) {
            this.showChat(this.chatsSorted[0].chats[0].id)
          }
        })
        .catch(errors => {
          this.loading = false
          this.loadingHisto = false
        })
        .then(_ => {
          this.loading = false
          this.loadingHisto = false
          this.listChats = true
        })
    },
    /**
     * Envoie un message à l'IA pour qu'elle l'analyse et
     * affiche la réponse de l'IA.
     */
    async sendMAnalyseChat () {
      console.log('send analyse')
      this.loadingData = true
      let urlAI = 'https://lb-sw-ai-prod.watcheebox.net/analyseSemantique'
      // si c'est en dev c'est pas la même url
      if (process.env.NODE_ENV === 'development') {
        // c'est du dev donc pas la même url
        urlAI = 'https://lb-sw-ai-dev-v2.watcheebox.net/analyseSemantique'
      } else if (process.env.NODE_ENV === 'preprod') {
        // c'est du dev donc pas la même url
        urlAI = 'https://lb-sw-ai-preprod-v2.watcheebox.net/analyseSemantique'
      }

      let conversationTexte = this.visiteurs.map(visiteur => {
        return `\n=== Conversations du visiteur ${visiteur.visId || 'inconnu'} ===` +
          visiteur.chats.map(chat => {
            let conversation = `\nConversation id:${chat.id}`
            let bloc = '' // bloc regroupant tous les messages du chat

            chat.messages.forEach(msg => {
              // conversion du timestamp en date complète
              const dateObj = new Date(parseInt(msg.unix, 10) * 1000)
              const dateComplete = dateObj.toLocaleString(`fr-FR`, {
                day: `2-digit`,
                month: `2-digit`,
                year: `numeric`,
                hour: `2-digit`,
                minute: `2-digit`,
                second: `2-digit`
              })

              // texte de base
              if (msg.auteur === 'Visiteur') {
                bloc += `'${dateComplete} - ${msg.auteur} id:${visiteur.visId}, message: ${msg.text}`
              } else if (msg.auteur === 'Agent') {
                bloc += `'${dateComplete} - ${msg.auteur} id:${msg.agentId}, message: ${msg.text}`
              }

              // si c'est un message du visiteur → indiquer à quel agent (id) il a été envoyé
              if (msg.auteur === `Visiteur` && msg.agentId) {
                bloc += `  (to agent Id:${msg.agentId})`
              }

              // si l’agent a fourni une liste d’URL
              if (msg.params && msg.params.listeMostRelevantUrl && msg.params.listeMostRelevantUrl.length > 0) {
                bloc += `\n   🔗 products:`
                msg.params.listeMostRelevantUrl.forEach((item, i) => {
                  bloc += `\n     product:${i + 1}, url:${item.url}, score:${item.similarityScore}`
                })
              }

              // si l’agent a utilisé une source pour sa réponse
              if (msg.params && msg.params.source) {
                bloc += `\n   🔗 Source:${msg.params.source}`
              }

              bloc += `\n' \n` // fermeture du message
            })

            return conversation + ': {\n' + bloc + '\n}'
          }).join('\n')
      }).join('\n')

      // ${this.analyseMessage}
      // Analyse les conversations suivantes entre un internaute et un agent.
      let promptDescription = `
        Pour analyse les conversations, fournis les éléments suivants :
        ${this.prompt}
        Si tu fais référence à un visiteur ou une conversation, Idique à chaque fois l'id du visiteur entre parenthèse.\n
        Ne pose jamais de question à la fin de tes réponses.
        ${this.analyseMessage}
        Liste des conversations :
        ${conversationTexte}
      `
      let dataMessage = {
        network: 'openAI',
        message: { type: 'text', content: this.analyseMessage },
        attachments: '',
        WZAgentId: this.$store.state._User.id,
        messageType: 1,
        auteur: 'Agent',
        siteId: this.$store.state._User.licenceId,
        entrepriseId: this.$store.state._User.entId,
        entrepriseKey: this.$store.state._User.entKey,
        licenceKey: this.$store.state._User.licAllKeys[0],
        chatSession: '',
        senderId: this.$store.state._User.id,
        jsonAPI: {},
        btob: 0,
        newFront: 1
      }

      let dataToPost = {
        promptDescription: promptDescription,
        searchResponse: '10',
        // tokenResponse: '12000',
        // model: 'gpt-4o-mini',
        // modelTokens: '128000',
        tokenResponse: '20000',
        model: 'gpt-5-nano',
        modelTokens: '400000',
        temperature: '0.5',
        dialogExemple: '',
        histoMessages: [],
        functionCalls: [],
        analyseChat: [],
        parsingSelectif: [],
        parseElement: '',
        methodSelect: '',
        jsonAPI: {},
        botStream: false,
        contextAI: '',
        dataMessage: dataMessage,
        syntheseVocale: 0,
        listeUrls: [],
        productSelectAuto: false,
        language: 'FR'
      }
      if (!this.analyseMessage.trim() && !this.prompt.length) return

      this.analyseResponse = '⏳ Réponse en cours...'

      // ✅ Retourne directement la Promise
      try {
        const response = await this.axios.post(
          urlAI,
          dataToPost
        )
        console.log('analyse bot response', response.data.data.data.response)
        if (response.data.data.data.response.includes('context_length_exceeded')) {
          this.analyseResponse = this.md.render(
            `
            **Désolé**, la quantité de données à analyser dépasse la capacité maximale autorisée pour cette requête. Cela peut arriver si la période ou le nombre de documents sélectionnés est trop important.
            Pour résoudre ce problème, je vous invite à :
            ***Réduire la période d’analyse*** (ex : limiter à un mois ou une semaine spécifique).
            `.trim()
          )
        } else {
          this.analyseResponse = this.md.render(response.data.data.data.response || 'Pas de réponse')
        }
        this.loadingData = false
        return {
          retour: 1,
          data: response.data
        }
      } catch (err) {
        console.log('analyse bot err', err)
        this.analyseResponse = this.md.render('❌ Erreur : ' + err.message)
        this.loadingData = false
        return {
          retour: 0,
          data: err
        }
      }
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapState('_User', ['entLevel']),
    suggestionsProxy: {
      get () {
        // Transformer l'objet {clé: valeur} en tableau [{cle, valeur}, ...]
        return Object.entries(this.suggestions).map(([cle, valeur]) => {
          return { cle, valeur }
        })
      },
      set (values) {
        // Transformer le tableau [{cle, valeur}, ...] en objet {clé: valeur}
        this.suggestions = values.reduce((acc, item) => {
          acc[item.cle] = item.valeur
          return acc
        }, {})
      }
    },
    prompt () {
      // Les clés sélectionnées
      const cles = Object.keys(this.suggestions)

      // Construire un texte enrichi avec description
      const details = cles.map(cle => {
        const q = this.questions.find(q => q.cle === cle)
        return `- ${q.valeur} → ${q.description}`
      }).join('\n')

      return `${details}`
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/analyse.vue